<template>
  <div v-show="password">
    <p class="font-weight-bold mb-50">
      {{ $t('shared.password-requirements.title') }}
    </p>
    <ul class="password-requirements list-unstyled mb-0">
      <li
        v-for="rule in requirementList"
        :key="rule.key"
        class="d-flex align-items-center password-requirements__item"
      >
        <feather-icon
          :icon="rule.fulfilled ? 'CheckIcon' : 'XIcon'"
          :class="['mr-50', rule.fulfilled ? 'text-success' : 'text-danger']"
          size="16"
        />
        <span :class="rule.fulfilled ? 'text-body' : 'text-muted'">{{ rule.label }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PasswordRequirements',
  props: {
    password: {
      type: String,
      default: '',
    },
  },
  computed: {
    requirementList() {
      const password = this.password || ''
      return [
        {
          key: 'length',
          label: this.$t('shared.password-requirements.length'),
          fulfilled: password.length >= 12,
        },
        {
          key: 'lowercase',
          label: this.$t('shared.password-requirements.lowercase'),
          fulfilled: /[a-z]/.test(password),
        },
        {
          key: 'uppercase',
          label: this.$t('shared.password-requirements.uppercase'),
          fulfilled: /[A-Z]/.test(password),
        },
        {
          key: 'digit',
          label: this.$t('shared.password-requirements.digit'),
          fulfilled: /\d/.test(password),
        },
        {
          key: 'special',
          label: this.$t('shared.password-requirements.special'),
          fulfilled: /[^A-Za-z0-9]/.test(password),
        },
      ]
    },
  },
}
</script>

<style scoped>
.password-requirements__item + .password-requirements__item {
  margin-top: 0.25rem;
}
</style>
